import { IActivityDetail } from './iactivity-detail';

export interface IDiuresisQuantityCodeableConcept {
    coding: string;
    text: string;
    // activityDetail: IActivityDetail[];
}
